module.exports = __webpack_public_path__ + "img/customer.d90acdfe.png";